import * as mobx from 'mobx';
import { ConnectionVersion } from '../../../../../../constants/common.constants';
import { IntlShape } from 'react-intl';
import { ASSIGN_V1_MEETINGS_TO_V1_ROOMS, ASSIGN_V2_MEETINGS_TO_V2_ROOMS } from './assign-room-form.texts';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';

interface IAssignRoomFormOption {
    label: string;
    value: ConnectionVersion;
}

export const connectionVersionOptions = (intl: IntlShape): IAssignRoomFormOption[] => {
    return [
        { label: intl.formatMessage(ASSIGN_V1_MEETINGS_TO_V1_ROOMS), value: ConnectionVersion.V1 },
        { label: intl.formatMessage(ASSIGN_V2_MEETINGS_TO_V2_ROOMS), value: ConnectionVersion.V2 },
    ];
};

class AssignRoomFormDataVM {
    @mobx.observable
    public connectionVersion: ConnectionVersion;

    constructor() {
        this.connectionVersion = hasPermission(Permission.CREATE_NEW_ROOM_V2) ? ConnectionVersion.V2 : ConnectionVersion.V1;
    }

    @mobx.action
    public setConnectionVersionField = (value: ConnectionVersion) => {
        this.connectionVersion = value;
    };
}

export { AssignRoomFormDataVM };